module.exports = {"npc_death":"Enemy death","player_death":"Player death","player_spell":"Bloodlust casts"};